//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ServiceCard from "./ServiceCard.vue";
import ServiceModal from "./ServiceModal.vue";

export default {
  name: 'ServiceSelection',
  data: function () {
    return {
      service: {},

      search: '',

      isOpenServiceModal: false
    }
  },
  props: ['services', "disableChangeUrl", "isSmall"],
  components: {
    ServiceCard,
    ServiceModal
  },
  computed: {
    list: function () {
      return this.services.filter((service) => {
        if (!this.search) {
          return service
        }

        const _search = String(this.search || '').toLowerCase();
        if (service.name.toLowerCase().indexOf(_search) === -1 && service.description.toLowerCase().indexOf(_search) === -1) {
          return null
        }

        return service
      })
    }
  },
  watch: {
    search: async function () {
      await this.mathHeightTitle();
    },
    services: async function () {
      await this.mathHeightTitle();
    },
  },
  mounted: function () {
    setTimeout( async () => {
      await this.mathHeightTitle();
    }, 500)
  },
  methods: {
    onSelect: function (service) {},
    onChangeSearch: function (event) {
      this.search = event.target.value;
    },

    openService: async function (slug) {
      const { data: service } = await this.$api.agent.transport.get(`operations/${slug}?expand=category,specialists,stores`).catch((err) => {
        return {data: null}
      });

      if (!service) {
        this.$customNotification.error("К сожаление, данной услуги нет.")

        return null
      }

      this.$refs.refServiceModal.open(service);
    },
    closeService: function () {
      this.service = {};
      this.isOpenServiceModal = false;
    },

    mathHeightTitle: async function () {
      if (this.$isServer) {
        return
      }

      const widthScreen = window.innerWidth;
      const gridSize = Boolean(widthScreen > 1499) ? 4 : Boolean(widthScreen > 999) ? 3 : 1;
      const listLength = this.list.length;
      const countLine = Math.ceil(listLength / gridSize);
      const allMatchTitles = document.querySelectorAll(".service-name");

      // Удаление стилей перед устоновкой максимальной высота
      await allMatchTitles.forEach(async (file) => {
        file.style = "";
      });

      // Удаление стилей максимальной высота
      for (let lineIndex = 0; lineIndex !== countLine; lineIndex++) {
        let maxHeightTitle = 0;
        for (let elementIndex = 0; elementIndex !== gridSize; elementIndex++) {
          const elementKey = elementIndex + ( lineIndex * gridSize );
          if ( maxHeightTitle < allMatchTitles[ elementKey ]?.clientHeight ) {
            maxHeightTitle = allMatchTitles[ elementKey ]?.clientHeight;
          }
        }
        for (let elementIndex = 0; elementIndex !== gridSize; elementIndex++) {
          const elementKey = elementIndex + ( lineIndex * gridSize );
          if (allMatchTitles[ elementKey ]) {
            allMatchTitles[ elementKey ].style = `height: ${maxHeightTitle}px`;
          }
        }
      }


      document.getElementById("container-service").style = "";
    }
  }
};
